<template>
  <profile new-profile v-model="show" :animation="null" unclosable></profile>
</template>

<script>
import Profile from '@/components/Profile'

export default {
  components: {
    Profile
  },

  data () {
    return {
      show: false
    }
  },

  mounted () {
    this.show = true
  }
}
</script>
